@if (NewlyAdded != undefined && NewlyAdded.length != 0) {
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <h3 class="headline margin-bottom-5 margin-top-30">Newly Added Properties</h3>
      </div>
    </div>
    <div class="row">
      @for (item of NewlyAdded; track item) {
        <div class="col-md-4 col-sm-6">
          <div class="listing-item">
            <div class="listing-img-container" (click)="showSlider(item)">
              <div class="listing-badges">
                <span>{{item.Purpose}}</span>
              </div>
              <div class="listing-img-content">
                <span class="listing-price">PKR {{item.Price}} <i>{{item.AreaUnit}}</i></span>
              </div>
              <div class="listing-carousel">
                <div>
                  <img [src]="item.Images[0]" alt="Property in Pakistan">
                </div>
              </div>
              <div class="total-pictures-count">
                <i class="fa fa-picture-o" aria-hidden="true"></i>
                {{item.Images.length}}
              </div>
            </div>
            <div class="listing-content">
              <div class="listing-title listing-home">
                <h4 class="text-truncate"><a [routerLink]="['/property', item.PropertyUrl]" attr.aria-label="{{item.Title}}">{{item.Title}}</a></h4>
              </div>
              <div class="listing-title listing-home">
                <div class="listing-address popup-gmaps text-truncate padding-bottom-10">
                  <i class="fa fa-map-marker"></i>
                  {{item.Location}}
                </div>
              </div>
              <div class="row listing-features margin-left-0 padding-left-0">
                @if (item.BedRooms != '') {
                  <div  class="col-md-3 col-sm-3 col-xs-3 padding-left-5">
                    <ul>
                      <li ><span><i class="fa fa-bed"></i>&nbsp;&nbsp;{{item.BedRooms}}</span></li>
                    </ul>
                  </div>
                }
                @if (item.BathRooms != '') {
                  <div  class="col-md-3 col-sm-3 col-xs-3 padding-left-5">
                    <ul class="text-center">
                      <li><div class="img-bath-room"></div><span>&nbsp;&nbsp;&nbsp;{{item.BathRooms}}</span></li>
                    </ul>
                  </div>
                }
                <div class="col-md-6 col-sm-6 col-xs-6 padding-left-5 text-truncate">
                  <span class="prop-length"><div class="img-compass"></div><span class="padding-left-20">{{item.AreaUnit}}</span></span>
                </div>
              </div>
              <div class="listing-footer">
                <div class="row padding-0">
                  <div class="col-md-6 col-xs-6 col-sm-6 padding-right-0">
                    <h5 class="text-truncate">
                      <div><i class="fa fa-user"></i> {{item.UserName}}</div>
                    </h5>
                  </div>
                  <div class="col-md-6 col-xs-6 col-sm-6">
                    <div class="pull-right"><i class="fa fa-calendar-o"></i> {{item.PublishDate}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
    <div class="row">
      <div class="col-md-12 text-center padding-bottom-15">
        <a class="button button-blue" [routerLink]="'/properties'" attr.aria-label="Search More Properties">Search More Properties</a>
      </div>
    </div>
  </div>
}
@if (IsLoading) {
  <div  class="container">
    <div class="row">
      <div class="col-md-12">
        <h3 class="headline margin-bottom-5 margin-top-30">Newly Added Properties</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-sm-6">
        <div class="listing-item">
          <div class="timeline-wrapper">
            <div class="timeline-item">
              <div class="animated-background">
                <div class="background-masker content-top-circle"></div>
                <div class="background-masker content-top"></div>
                <div class="background-masker content-top-end"></div>
                <div class="background-masker content-first-end"></div>
                <div class="background-masker content-second-line"></div>
                <div class="background-masker content-second-end"></div>
                <div class="background-masker content-second-end-two"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-sm-6 hidden-xs">
        <div class="listing-item">
          <div class="timeline-wrapper">
            <div class="timeline-item">
              <div class="animated-background">
                <div class="background-masker content-top-circle"></div>
                <div class="background-masker content-top"></div>
                <div class="background-masker content-top-end"></div>
                <div class="background-masker content-first-end"></div>
                <div class="background-masker content-second-line"></div>
                <div class="background-masker content-second-end"></div>
                <div class="background-masker content-second-end-two"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 hidden-xs hidden-sm hidden-xs">
        <div class="listing-item">
          <div class="timeline-wrapper">
            <div class="timeline-item">
              <div class="animated-background">
                <div class="background-masker content-top-circle"></div>
                <div class="background-masker content-top"></div>
                <div class="background-masker content-top-end"></div>
                <div class="background-masker content-first-end"></div>
                <div class="background-masker content-second-line"></div>
                <div class="background-masker content-second-end"></div>
                <div class="background-masker content-second-end-two"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
<div id="dynamicLightGallery"></div>
